<div id="users-component" class="users-component d-flex flex-column align-items-start justify-content-start p-1 p-md-3">
    <div
        class="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between w-100 gap-2 mb-2"
    >
        <mat-form-field class="flex-grow-1">
            <mat-label>Search Users</mat-label>
            <input matInput type="search" [(ngModel)]="keyword" (keydown.enter)="search()" />
            <button matSuffix mat-icon-button aria-label="Search" (click)="search()">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Sort order</mat-label>
            <mat-select [(value)]="sortOrder" (selectionChange)="sortOrderChanged()">
                @for (sortOrder of sortOrders; track $index) {
                    <mat-option [value]="sortOrder">{{ UsersSortOrders[sortOrder] }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="table-responsive w-100">
        <table mat-table [dataSource]="users" class="mat-elevation-z8 my-3 w-100">
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell">ID</th>
                <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">{{ element.id }}</td>
            </ng-container>
            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef>First Name</th>
                <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
            </ng-container>
            <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef class="d-none d-sm-table-cell">Last Name</th>
                <td mat-cell *matCellDef="let element" class="d-none d-sm-table-cell">{{ element.lastName }}</td>
            </ng-container>
            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef class="d-none d-md-table-cell">Username</th>
                <td mat-cell *matCellDef="let element" class="d-none d-md-table-cell">{{ element.userName }}</td>
            </ng-container>
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>
            <ng-container matColumnDef="brokerAccountsCount">
                <th mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell">Broker Accounts</th>
                <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">
                    {{ element.brokerAccountsCount }}
                </td>
            </ng-container>
            <ng-container matColumnDef="botsCount">
                <th mat-header-cell *matHeaderCellDef class="d-none d-lg-table-cell">Bots</th>
                <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell">{{ element.botsCount }}</td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef class="d-none d-md-table-cell">Created At</th>
                <td mat-cell *matCellDef="let element" class="d-none d-md-table-cell">
                    {{ element.createdAt | date: "short" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="actions-column">Actions</th>
                <td mat-cell *matCellDef="let element" class="actions-column">
                    <div class="actions-wrapper">
                        <button
                            mat-icon-button
                            color="primary"
                            (click)="viewUserInfo(element.id)"
                            matTooltip="View user info"
                        >
                            <mat-icon>visibility</mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            color="primary"
                            (click)="viewSubscriptions(element.id)"
                            matTooltip="View user subscriptions"
                        >
                            <mat-icon>paid</mat-icon>
                        </button>
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="User menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="loginAs(element.id)">
                                <mat-icon>login</mat-icon>
                                <span>Login As</span>
                            </button>
                            <button mat-menu-item (click)="deleteUser(element.id)">
                                <mat-icon color="warn">delete</mat-icon>
                                <span>Delete User</span>
                            </button>
                        </mat-menu>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <mat-paginator
        #paginator
        class="demo-paginator"
        (page)="pageChanged($event)"
        [length]="totalUsers"
        [pageSize]="pageSize"
        [disabled]="false"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [hidePageSize]="false"
        [pageIndex]="page"
        aria-label="Select page"
    >
    </mat-paginator>
</div>
